import React, { Fragment, PureComponent } from 'react';
import { ExchangeRates } from '~/Api/User/ExchangeRate';
import { RateTimePeriod } from '~/ExchangeRate/RateTimePeriod';
import Button, { Link } from '~/UI/Button';
import primaryAltSmallButtonStyles from '~/UI/Button/primary-alt-small.less';
import secondarySmallButtonStyles from '~/UI/Button/secondary-small.less';
import Heading from '~/UI/Heading/Heading';
import inputCompactStyles from '~/UI/Input/compact.less';
import Input from '~/UI/Input/Input';

import styles from './styles.less';

interface Props {
	selectedRates: ExchangeRates | null;
	selectedDate: Date | null;
	selectedBaseCurrency: string | null;
	changedRates: {
		[currency: string]: {
			raw: string;
			parsed: number | null;
			isValid: boolean;
		};
	};
	isUpdating: boolean;
	disableSubmit: boolean;
	name: string;
	styles: {
		footerButton: string;
		paragraph: string;
		ratesName: string;
		nameInputContainer: string;
	};
	onClose(): void;
	onNameChange(name: string): void;
}

export default class SelectModalControls extends PureComponent<Props> {
	static defaultProps = {
		styles,
	};

	render() {
		const { changedRates, isUpdating, disableSubmit, styles, onClose } = this.props;
		const hasInvalidRate = Object.keys(changedRates).find((currency) => !changedRates[currency].isValid) !== undefined;

		return (
			<Fragment>
				<Heading level={3}>
					<strong>Settings summary:</strong>
				</Heading>
				{this.renderSummary()}

				<Link styles={secondarySmallButtonStyles} onClick={isUpdating ? undefined : onClose}>
					Close
				</Link>
				<div className={styles.footerButton}>
					<Button disabled={hasInvalidRate || disableSubmit} styles={primaryAltSmallButtonStyles}>
						Save Settings
					</Button>
				</div>
			</Fragment>
		);
	}

	renderSummary() {
		const { selectedRates, selectedDate, selectedBaseCurrency, changedRates, name, styles, onNameChange } = this.props;

		if (!selectedRates) {
			return null;
		}

		if (
			Object.keys(changedRates).length > 0 ||
			selectedRates.isCustom() ||
			selectedRates.baseCurrency !== selectedBaseCurrency
		) {
			return (
				<Fragment>
					<p className={styles.paragraph}>
						Use <strong>custom exchange rate</strong> with name:
					</p>
					<div className={styles.ratesName}>
						<div className={styles.nameInputContainer}>
							<Input
								styles={inputCompactStyles}
								value={name}
								onChange={(event) => onNameChange(event.currentTarget.value)}
							/>
						</div>
					</div>
				</Fragment>
			);
		}

		if (selectedDate) {
			return (
				<p className={styles.paragraph}>
					Use <strong>{selectedRates.name} exchange rate</strong>{' '}
					<RateTimePeriod
						averageLabel='average'
						date={selectedDate}
						fromLabel='from'
						timePeriod={selectedRates.timePeriod}
					/>
				</p>
			);
		}

		return (
			<p className={styles.paragraph}>
				Use up to date <strong>{selectedRates.name} exchange rate</strong>
			</p>
		);
	}
}
